<template>
  <ankh-list>
    <template #btn-group>
      <el-button @click.native="handleShowFormDialog()">{{$t('新增')}}</el-button>
      <el-button @click.native="handleBatchDelete">{{$t('批量删除')}}</el-button>
      <el-button @click.native="handleExport">{{$t('导出')}}</el-button>
    </template>

    <template #search-form>
      <el-form-item :label="$t('时间')">
        <date-time-range-picker
            :end-time.sync="searchForm.endTime"
            :start-time.sync="searchForm.startTime" />
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="$refs.list.handleSearch()">{{$t('搜索')}}</el-button>
        <el-button @click="$refs.list.reset()">{{$t('重置')}}</el-button>
      </el-form-item>
    </template>

    <template #table="{height}">
      <table-list
          ref="list"
          :height="height"
          @query="handleSearch"
          :request-params="requestParams"
          :search-params="searchForm"
          :data="tableData"
          @sort-change="handleSort"
          @selection-change="selection = $event">

        <el-table-column type="selection" width="50"/>
        <el-table-column type="index" width="50" :label="$t('序号')" />
        <el-table-column prop="name" :label="$t('激活码名称')" />
        <el-table-column :label="$t('创建时间')" sortable="custom">
          <template v-slot="{row}">
            {{row.createTime | formatTime}}
          </template>
        </el-table-column>
        <el-table-column :label="$t('开始时间')" >
          <template v-slot="{row}">
            {{row.startTime | formatTime}}
          </template>
        </el-table-column>
        <el-table-column :label="$t('结束时间')">
          <template v-slot="{row}">
            {{row.endTime | formatTime}}
          </template>
        </el-table-column>
        <el-table-column prop="brandName" :label="$t('蓝牙MAC状态')">
          <template v-slot="{row}">
            <dict-text dict-flag="MEMBER_MAC_CODE_STATUS" :status="row.macStatus" />
          </template>
        </el-table-column>
        <el-table-column prop="brandName" :label="$t('品牌名称')"/>

        <el-table-column prop="phone" :label="$t('品牌图片')">
          <template v-slot="{row}">
            <preview-img :size="60" :img-url="row.brandPhoto" />
          </template>
        </el-table-column>
        <el-table-column prop="address" :label="$t('会员类型')">
          <template v-slot="{row}">
            <dict-text dict-flag="VIP_TYPE" :status="row.vipType" />
          </template>
        </el-table-column>
        <el-table-column prop="convertNumber" :label="$t('兑换会员期限/月')"/>
        <el-table-column prop="createCount" :label="$t('生成数量')"/>
        <el-table-column :label="$t('发放数量')">
          <template v-slot="{row}">
            {{row.createCount * row.activateCount}}
          </template>
        </el-table-column>
        <el-table-column prop="activateCount" :label="$t('激活次数上限')"/>


        <el-table-column prop="alreadyActCount" :label="$t('已激活数量')"/>

        <el-table-column :label="$t('发布时间')">
          <template v-slot="{row}">
            {{row.releaseTime | formatDate}}
          </template>
        </el-table-column>

        <el-table-column :label="$t('状态')">
          <template v-slot="{row}">
            <dict-text dict-flag="ACTIVE_CODE_STATUS" :status="row.status" />
          </template>
        </el-table-column>
        <el-table-column  :label="$t('操作')" width="200">
          <template v-slot="{row}">
            <div class="fb-link-flex">
              <el-link type="primary" :underline="false" @click="$router.push('detail?code=' + row.code)">{{$t('查看明细')}}</el-link>
              <el-link type="primary" :underline="false" @click="handleShowFormDialog(row)">{{$t('编辑')}}</el-link>
              <el-link type="primary" :underline="false" @click="handleChangeStatus(row)">{{ row.status === "open" ? $t('禁用') : $t('启用') }}</el-link>
              <el-link type="danger" :underline="false" @click="handleDelete(row)">{{$t('删除')}}</el-link>
            </div>
          </template>
        </el-table-column>
      </table-list>
    </template>

    <template slot="other">
      <add-or-edit ref="addOrEdit" :is-edit="isEdit" :data="currentRow" @save="handleAddOrEditSubmit" />
    </template>
  </ankh-list>
</template>

<script>
import {request, requestByTip} from "@/config/request";
import TableList from "@/components/table-list/TableList";
import DateTimeRangePicker from "@/components/time/DateTimeRangePicker";
import AddOrEdit from "@/components/active-code/AddOrEdit";
import DictText from "@/components/dict/DictText";
import PreviewImg from "@/components/preview-img/PreviewImg.vue";
import AnkhList from "@/components/list/AnkhList.vue";
import {exportExcel} from "@/utils/export";

export default {
  name: "ActiveCodeList",
  components: {AnkhList, PreviewImg, DictText, AddOrEdit, DateTimeRangePicker, TableList},
  data() {
    return {
      searchForm: {},
      tableData: [],
      selection: [],
      isEdit: false,
      currentRow: {},
      requestParams: {}
    }
  },
  methods: {
    handleSort(e) {
      const sortMap = {
        "ascending": "asc",
        "descending": "desc",
      }
      this.requestParams.orderCreateTime = sortMap[e.order];
      this.$refs.list.handleRequest();
    },

    // 新增/编辑提交
    async handleAddOrEditSubmit(data) {
      try {
        if(this.isEdit) data.code = this.currentRow.code;
        const action = this.$api.activateCode[this.isEdit ? "update" : "add"];
        await request(action, data);
        this.$message.success(this.$t("操作成功"));
        this.$refs.list.handleRequest();
        this.$refs.addOrEdit.showDialog = false;
      } catch (e) {
        console.log(e);
      }
    },

    // 打开新增/编辑弹窗
    handleShowFormDialog(row) {
      if(row) {
        this.isEdit = true;
        row = {...row};
        row.startTime = this.$moment(row.startTime).format("YYYY-MM-DD HH:mm:ss");
        row.endTime = this.$moment(row.endTime).format("YYYY-MM-DD HH:mm:ss");
        this.currentRow = row;
      } else {
        this.isEdit = false;
      }
      this.$refs.addOrEdit.showDialog = true;
    },

    // 启用/禁用
    async handleChangeStatus(row) {
      try {
        const params = {
          code: row.code,
          status: row.status === "open" ? "close" : "open",
        }
        await request(this.$api.activateCode.updateStatus, params);
        this.$message.success(this.$t("操作成功"));
        this.$refs.list.handleRequest();
      } catch (e) {
        console.log(e);
      }
    },

    async handleDelete(row) {
      try {
        await requestByTip(this.$api.activateCode.delete, {code: row.code});
        this.$message.success(this.$t("操作成功"));
        this.$refs.list.handleRequest(1);
      } catch (e) {
        console.error(e);
      }
    },

    async handleBatchDelete() {
      try {
        let codes = this.selection.map(item => item.code);
        if(!codes.length) {
          this.$message.warning(this.$t("请选择要删除的项"));
          return;
        }
        await requestByTip(
            this.$api.activateCode.batchDelete,
            codes,
            {isJson: true},
            {message: this.$t("您现在正在进行批量删除操作, 是否继续?")}
        );
        this.$message.success(this.$t("操作成功"));
        this.$refs.list.handleRequest(codes.length);
      } catch (e) {
        console.error(e);
      }
    },

    async handleSearch(params, setTotal) {
      try {
        const res = await request(this.$api.activateCode.list, params);
        for (let key in res) {
          if (res[key] instanceof Array) {
            this.tableData = res[key];
          }
        }
        setTotal(res.pager?.itemCount);
      } catch (e) {
        console.error(e);
      }
    },
    handleExport() {
      // console.log(this.selection);
      const codes=this.selection.map(item=>item.code);
      exportExcel(codes,this.$api.activateCode.export);
    }
  },

}
</script>

<style scoped>

</style>
